import { render } from "./DialogCouponCancelCompleted.vue?vue&type=template&id=13b7924b"
import script from "./DialogCouponCancelCompleted.vue?vue&type=script&lang=js"
export * from "./DialogCouponCancelCompleted.vue?vue&type=script&lang=js"
script.render = render

export default script